/* eslint-disable react/prop-types */ import React from 'react';
import classNames from 'classnames';
import { IconWrapper } from '../RightMenu/Product';
var ProductIndicator = function(param) {
    var className = param.className, categoryName = param.categoryName, isSecondary = param.isSecondary, _param_isFocused = param.isFocused, isFocused = _param_isFocused === void 0 ? false : _param_isFocused, _param_isDisabled = param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('product-indicator', categoryName, className, isSecondary && 'secondary')
    }, /*#__PURE__*/ React.createElement(IconWrapper, {
        icon: categoryName,
        isActive: isFocused,
        isSecondary: isSecondary,
        isDisabled: isDisabled
    }));
};
export default ProductIndicator;
